"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Row = _interopRequireDefault(require("@emcasa/ui-dom/components/Row"));

var _Button = _interopRequireDefault(require("@emcasa/ui-dom/components/Button"));

var _reactInputMask = _interopRequireDefault(require("react-input-mask"));

var _styles = require("../shared/styles");

var _ = _interopRequireDefault(require("../.."));

var _loading = _interopRequireDefault(require("../loading"));

var _ref2 =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.TitleText, {
  color: "pink"
}, void 0, "C\xF3digo enviado");

var _ref3 =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.InfoText, {}, void 0, "Digite o c\xF3digo enviado para o seu Whatsapp");

var _ref4 =
/*#__PURE__*/
(0, _jsx2["default"])(_loading["default"], {});

var Token =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Token, _Component);

  function Token(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Token);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Token).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "tokenInput", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyPressed", function (_ref) {
      var keyCode = _ref.keyCode;

      if (keyCode === 13) {
        _this.onSubmit();

        return false;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeToken", function (event) {
      var value = event.target.value;

      if (_this.state.errorMessage) {
        _this.setState({
          errorMessage: null
        });
      }

      _this.setState({
        token: value
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearToken", function (phone) {
      var charsToClean = [' ', '_'];
      var newPhone = phone;
      charsToClean.forEach(function (_char) {
        newPhone = newPhone.split(_char).join('');
      });
      return newPhone;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "submitToken", function (token) {
      _this.setState({
        isLoading: true
      });

      _this.props.submitToken(token).then(function () {
        return _this.props.goToStep(_["default"].STEP_NAMES.success);
      })["catch"](function () {
        return _this.props.goToStep(_["default"].STEP_NAMES.tokenError);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSubmit", function () {
      if (_this.state.errorMessage) {
        _this.setState({
          errorMessage: null
        });
      }

      var cleanToken = _this.clearToken(_this.state.token);

      if (cleanToken.length !== 4) {
        _this.setState({
          errorMessage: Token.ERROR_MESSAGES.invalidToken
        });
      } else {
        _this.submitToken(cleanToken);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isButtonDisabled", function () {
      return _this.clearToken(_this.state.token).length !== 4;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBack", function () {
      return _this.props.goToStep(_["default"].STEP_NAMES.phone);
    });
    _this.state = {
      token: '',
      errorMessage: null,
      isLoading: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Token, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.tokenInput.current.focus();
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      return (0, _jsx2["default"])(_Row["default"], {
        flexDirection: "column"
      }, void 0, _ref2, _ref3, (0, _jsx2["default"])(_reactInputMask["default"], {
        mask: "9 9 9 9",
        onChange: this.changeToken,
        onKeyDown: this.onKeyPressed
      }, void 0, _react["default"].createElement(_styles.CenterInput, {
        height: "medium",
        mt: 4,
        mb: 2,
        placeholder: "9 9 9 9",
        pattern: "\\d*",
        inputMode: "numeric",
        hideLabelView: true,
        ref: this.tokenInput
      })), (0, _jsx2["default"])(_Row["default"], {}, void 0, (0, _jsx2["default"])(_Button["default"], {
        fluid: true,
        mr: 3,
        onClick: this.onBack
      }, void 0, "Voltar"), (0, _jsx2["default"])(_styles.CTAButton, {
        fluid: true,
        active: true,
        disabled: this.isButtonDisabled(),
        onClick: this.onSubmit
      }, void 0, "Enviar")));
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.isLoading ? _ref4 : this.renderForm();
    }
  }]);
  return Token;
}(_react.Component);

(0, _defineProperty2["default"])(Token, "ERROR_MESSAGES", {
  invalidToken: 'Por favor, entre com um token de 6 digitos'
});
var _default = Token;
exports["default"] = _default;